/**
 * @file 认证流程
 * @author
 */
// @ts-nocheck
import React, {Fragment} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {Tooltip} from 'antd';
import {recordProxy} from '../../util';
import iconAuthFlow1 from './imgs/icon-auth-flow-1.png';
import iconAuthFlow2 from './imgs/icon-auth-flow-2.png';
import iconAuthFlow3 from './imgs/icon-auth-flow-3.png';
import iconTip from '../../asset/img/icons/icon-tip.svg';
import AuthForm from './authForm';
import './form.less';

interface Props {
    title: string;
}

export default function Procedure(props: Props) {
    const {pathname} = useLocation();
    const history = useHistory();
    const jump = (type: string) => {
        let routerPath = '';
        switch (type) {
            case 'partner':
                routerPath = '/partner';
                break;
            case 'specialAuth':
                routerPath = '/attest/step/1';
                break;
            default:
        }
        recordProxy('newAttest', 'click', routerPath.replace('/', ''));
        routerPath && history.push(routerPath);
    };

    const showSubTitle = !['/call_auth'].includes(pathname);
    return (
        <Fragment>
            <div className="auth-flow" id="page-attest-anchor-auth">
                <p className="common-title">{props.title || '认证流程'}</p>
                {showSubTitle && <div className="tip">
                    我们为政府、非盈利机构开放特殊认证渠道，
                    <span className="link" onClick={() => jump('specialAuth')}>前往认证</span>
                    <Tooltip
                        // trigger="click"
                        title={
                            <span className="page-attest-tooltip-content">
                                认证范围：教育；卫生、医疗和社会工作；文化、体育和娱乐；旅游、住宿、餐饮和出行；公共管理、社会保障和社会组织
                            </span>
                        }
                    >
                        <img className="icon-tip" src={iconTip}></img>
                    </Tooltip>
                </div>}
                <div className="flow-progress-wrapper">
                    <div className="imgs-list">
                        <img className="progress-img" src={iconAuthFlow1}></img>
                        <img className="progress-img" src={iconAuthFlow2}></img>
                        <img className="progress-img" src={iconAuthFlow3}></img>
                    </div>
                    <div className="title-list">
                        <span className="title">1.填写信息</span>
                        <span className="divider"></span>
                        <span className="title">2.专业服务</span>
                        <span className="divider"></span>
                        <span className="title">3.审核上线</span>
                    </div>
                    <div className="tip-list">
                        <div className="item-tip">
                            <p>填写企业信息及联系方式，</p>
                            <p>等待客服回访</p>
                        </div>
                        <div className="item-tip">
                            <span>百度</span>
                            <span className="link" onClick={() => jump('partner')}>官方合作伙伴</span>与您电话沟通，
                            <p>提供一对一协助号码认证服务</p>
                        </div>
                        <div className="item-tip">
                            <p>付费完成后，</p>
                            <p>审核通过并上线</p>
                        </div>
                    </div>
                </div>
                <div className="auth-info-wrapper">
                    <div className="auth-tip-bg"></div>
                    <div className="auth-info">
                        <AuthForm {...props}/>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
